import { defineComponent } from "vue";
import OptionBaseControl from "./OptionBaseControl";
export default defineComponent({
  name: "ComboBox",
  extends: OptionBaseControl,
  methods: {
    reset(silent: boolean = true) {
      this.setValue(this.defaultState.value ? this.defaultState.value : null, silent);
      //this.config.editedParentRowNumber = null;
      //this.resetErrors();
    },
  },
});
